module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/icon_title_leaf-7a74f3f98258887d1d5df8bdc8a98979.png";